<template>
  <v-layout wrap justify-center >
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" right color="#FEBD08">
      <v-layout wrap>
        <v-flex xs11>
          {{ msg }}
        </v-flex>
        <v-flex xs1>
          <v-icon @click="showSnackBar = !showSnackBar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- <v-flex xs12 pb-lg-12 pb-5><v-divider></v-divider></v-flex> -->
    <v-flex xs10 md12 pb-lg-12 pb-5 >
      <v-layout wrap>
        <v-flex pt-3 pb-6 xs12 text-left v-if="productDetail.productId">
          <span style="color: #000; font-size: 22px; font-family: poppinsbold"
            >{{ productDetail.productId.name }}
          </span>
        </v-flex>
      </v-layout>
      <v-layout wrap class="RR" >
        <v-flex
          xs12
          sm3
          md3
          lg2
          align-self-start
          v-if="productDetail.photo != null"
        >
          <div v-viewer style="display: flex">
            <span>
              <img
                style="object-fit: contain; cursor: pointer"
                :src="mediaURL + productDetail.photo"
                height="160px"
                width="160px"
                contain
              />
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm3 md3 lg2 pt-sm-6 align-self-start v-else>
          <v-img
            height="160px"
            width="160px"
            contain
            :src="require('../../assets/images/no-image.png')"
          >
          </v-img>
        </v-flex>
        <v-flex xs12 sm12 md6>
          <v-layout wrap>
            <v-flex xs12 sm12 md6 align-self-start>
              <v-layout wrap>
                <v-flex
                  align-self-start
                  text-left
                  xs12
                  pt-3
                  v-if="productDetail"
                >
                  <b>Seller Name :</b>
                  <span v-if="productDetail.sellerId">
                    {{ productDetail.sellerId.contactPerson }}</span
                  >
                </v-flex>
                <v-flex
                  align-self-start
                  text-left
                  xs12
                  pt-3
                  v-if="productDetail.categoryId"
                >
                  <b>Categoory :</b> {{ productDetail.categoryId.name }}
                </v-flex>
                <v-flex
                  align-self-start
                  text-left
                  xs12
                  pt-3
                  v-if="productDetail.subcategoryId"
                >
                  <b>Sub - Category :</b> {{ productDetail.subcategoryId.name }}
                </v-flex>
                <v-flex
                  v-if="productDetail.preparationTime"
                  xs12
                  pt-2
                  align-self-start
                  text-left
                >
                  <span>
                    <b> Preparation Time :</b>
                    {{ getTimeFromMins(productDetail.preparationTime) }}
                  </span>
                </v-flex>
                <v-flex
                  xs12
                  pt-2
                  align-self-start
                  text-left
                  v-if="productDetail.isAllTime"
                >
                  <span>
                    <b> Product Availability:</b>
                    24 x 7
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md6 align-self-start>
              <v-layout wrap>
                <v-flex xs12 pt-2 align-self-start text-left> </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 text-left>
              <v-rating
                readonly
                :value="productDetail.rating"
                color="yellow darken-3"
                background-color="grey "
                empty-icon="$ratingFull"
                half-increments
                hover
              ></v-rating>
            </v-flex>
            <v-flex pt-3 xs12 sm12 text-left pb-3>
              <v-layout wrap>
                <v-flex xs6 sm4 md3 py-2 text-left>
                  <span class="pr-2">
                    <v-btn
                      depressed
                      small
                      color="info"
                      @click="
                        $router.push(
                          '/EditGroceryProduct?id=' +
                            $route.query.id +
                            '&seller=' +
                            productDetail.sellerId.uid +
                            '&productId=' +
                            productDetail.productId._id
                        )
                      "
                      >Update</v-btn
                    >
                  </span>
                </v-flex>
                <v-flex xs6 sm4 md3 py-2 text-left>
                  <span class="pl-2">
                    <v-btn
                      color="red"
                      depressed
                      small
                      @click="deleteDialog = true"
                    >
                      <span style="color: #fff">Remove</span></v-btn
                    >
                  </span>
                </v-flex>
                <v-flex xs6 sm4 md3 py-2 text-left>
                  <span v-if="productDetail.status == 'Inactive'">
                    <v-btn color="green" @click="statusDialog = true" small
                      ><span style="color: #fff">Enable </span>
                    </v-btn>
                  </span>
                  <span v-if="productDetail.status == 'Active'">
                    <v-btn color="red" @click="statusDialog = true" small
                      ><span style="color: #fff">Disable </span>
                    </v-btn>
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 sm4 md3 lg4>
          <v-layout wrap justify-center>
            <v-flex xs6 pr-1 v-if="productDetail.productPhoto != null">
              <div v-viewer style="display: flex">
                <span>
                  <img
                    style="object-fit: contain; cursor: pointer"
                    :src="mediaURL + productDetail.productPhoto"
                    height="160px"
                    width="160px"
                    contain
                  />
                </span>
              </div>
            </v-flex>
            <v-flex xs6 pl-1 v-if="productDetail.packedPhoto">
              <div v-viewer style="display: flex">
                <span>
                  <img
                    style="object-fit: contain; cursor: pointer"
                    :src="mediaURL + productDetail.packedPhoto"
                    height="160px"
                    width="160px"
                    contain
                  />
                </span>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          xs12
          text-left
          v-if="productDetail.benefits"
          style="font-family: robotomedium"
        >
          BENEFITS
        </v-flex>
        <v-flex
          text-left
          v-if="productDetail.benefits"
          xs12
          class="text"
          align-self-end
        >
          {{ productDetail.benefits }}
        </v-flex>

        <v-flex text-left pt-3 style="font-family: robotomedium">
          DESCRIPTION
        </v-flex>
        <v-flex pl-2 pb-5 text-left xs12 class="text">
          <v-layout>
            <span v-if="productDetail.productId">
              {{ productDetail.productId.description }}
            </span>
          </v-layout>
        </v-flex>
        <v-flex
          text-left
          xs12
          pt-1
          style="font-family: robotomedium"
          v-if="productDetail.hsnCode && productDetail.hsnCodeId"
        >
          HSN DETAILS
        </v-flex>
        <v-flex pb-5 pt-1 text-left xs8 class="text">
          <v-layout
            wrap
            pl-2
            class="text"
            v-if="productDetail.hsnCode && productDetail.hsnCodeId"
          >
            <v-flex xs4 md2>
              <b> HSN Code</b>
            </v-flex>
            <v-flex xs8 md10 text-left>
              {{ productDetail.hsnCode }}
            </v-flex>
            <v-flex xs4 md2>
              <b> Name</b>
            </v-flex>
            <v-flex xs8 md10>
              {{ productDetail.hsnCodeId.name }}
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex pb-5 pt-1 text-left xs4 class="text" align-self-center>
          <v-layout wrap pl-3 class="text" v-if="productDetail.hsnCodeId">
            <v-flex xs8>
              <b>GST Slab 1 Percentage % </b>
            </v-flex>
            <v-flex xs4>
              {{ productDetail.hsnCodeId.gstSlab1Percentage }}
            </v-flex>
            <v-flex xs8>
              <b>GST Slab 2 Percentage %</b>
            </v-flex>
            <v-flex xs4>
              {{ productDetail.hsnCodeId.gstSlab2Percentage }}
            </v-flex>
            <v-flex xs8>
              <b>GST Slab2 Minimum Price ₹</b>
            </v-flex>
            <v-flex xs4>
              {{ productDetail.hsnCodeId.gstSlab2MinimumPrice }}
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 text-left  >
          <v-layout wrap>
            <v-flex xs12>
              <v-card class="mb-2">
                <v-layout pa-5 wrap v-for="(item, i) in variants" :key="i">
                  <v-flex
                    xs12
                    pt-2
                    align-self-start
                    text-center
                    style="
                      background-color: grey;
                      font-size: 20px;
                      border-radius: 4px;
                    "
                    class="white--text"
                  >
                    <span>
                      <b>Variant {{ i + 1 }}</b>
                    </span>
                  </v-flex>

                  <v-flex xs12 sm2 pt-2 style="background-color: ">
                    <img
                      style="object-fit: contain; cursor: pointer"
                      :src="mediaURL + item.photo"
                      height="160px"
                      width="160px"
                      contain
                    />
                  </v-flex>
                  <v-flex sm10 pt-1>
                    <v-layout wrap fill-height>
                      <v-flex xs12 md6 align-self-center>
                        <v-layout wrap>
                          <v-flex xs5>
                            <b>Name </b>
                          </v-flex>
                          <v-flex xs7>
                            {{ item.varientName }}
                          </v-flex>
                          <v-flex xs5>
                            <b>Price </b>
                          </v-flex>
                          <v-flex xs7>
                            {{ item.price }}
                          </v-flex>
                          <v-flex xs5>
                            <b>Discount</b>
                          </v-flex>
                          <v-flex xs7> {{ item.discount }} % </v-flex>
                          <v-flex xs5>
                            <b>Quantity </b>
                          </v-flex>
                          <v-flex xs7>
                            {{ item.quantity }} {{ item.quantityType }}
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 md6 align-self-center>
                        <v-layout wrap>
                          <v-flex xs5>
                            <b>Min Order Quantity :</b>
                          </v-flex>
                          <v-flex xs7>
                            {{ item.minimumOrderQuantity }}
                          </v-flex>
                          <v-flex xs5>
                            <b>Max Order Quantity :</b>
                          </v-flex>
                          <v-flex xs7>
                            {{ item.maxOrderQuantity }}
                          </v-flex>
                          <v-flex xs12 align-self-baseline pt-3>
                            <span v-if="item.status == 'Inactive'">
                              <v-btn
                                tile
                                text
                                style="text-decoration: none"
                                color="green"
                                x-small
                                dark
                                @click="
                                  (VariantstatusDialog = true),
                                    (variantdetails = item)
                                "
                              >
                                Enable Variant {{ i + 1 }}
                              </v-btn>
                            </span>
                            <span v-if="item.status == 'Active'">
                              <v-btn
                                tile
                                text
                                x-small
                                style="text-decoration: none"
                                color="red"
                                dark
                                @click="
                                  (VariantstatusDialog = true),
                                    (variantdetails = item)
                                "
                              >
                                Disable Variant {{ i + 1 }}
                              </v-btn>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 pt-2 align-self-start text-left>
                    <span> </span>
                  </v-flex>
                  <v-flex xs12 px-1>
                    <v-divider> </v-divider>
                  </v-flex>
                  <v-flex pl-1 xs6 pt-2>
                    <b>Stock Details</b>
                  </v-flex>
                  <v-flex pr-1 xs6 text-right pt-2>
                    <router-link :to="'previousStock?id=' + item._id">
                      <v-btn
                        style="
                          margin-right: 6px;
                          text-decoration: none !important;
                        "
                        x-small
                        dark
                        color="#ff751b"
                        rounded
                      >
                        View Old Stock
                      </v-btn>
                    </router-link>

                    <v-btn
                      dark
                      rounded
                      x-small
                      color="#ff751a"
                      @click="
                        (openStockDialog = true),
                          (newStock.varientId = item._id)
                      "
                    >
                      Add New Stock <v-icon x-small>mdi-plus</v-icon>
                    </v-btn>
                  </v-flex>

                  <v-flex xs12 text-center v-if="item.stock.length < 1">
                    Empty Stock.......!
                  </v-flex>
                  <v-flex xs12>
                    <!-- :hsnId="productDetail.hsnCodeId._id" -->
                    <StockInfo
                      :hsnId="
                        productDetail.hsnCodeId
                          ? productDetail.hsnCodeId._id
                          : ''
                      "
                      :stock="item.stock"
                      :mainVariantId="item._id"
                      @stepper="winStepper"
                    />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          v-if="
            productDetail.availableTimings &&
            productDetail.availableTimings.length > 0 &&
            !productDetail.isAllTime
          "
          pb-8
          xs12
          sm8
          md9
        >
        </v-flex>

        <v-flex xs12 md12 px-lg-0 pb-12 px-2 text-left>
          <v-card color="#FAFAFA" tile> </v-card>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-dialog persistent v-model="verifyDelete" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="#ffffff" v-on="on" v-bind="attrs">mdi-delete</v-icon>
      </template>
      <v-card>
        <v-card-title>{{ notice }}</v-card-title>
        <v-card-title>
          <v-layout wrap v-if="isReject">
            <v-flex xs12 pa-40>
              <v-form v-model="validates" ref="form">
                <v-textarea
                  outlined
                  color="warning"
                  name="input-7-4"
                  v-model="reason"
                  :rules="[req.required]"
                  label="Enter the remarks"
                ></v-textarea>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="(verifyDelete = false), (isReject = false), (reason = '')"
            >Cancel</v-btn
          >
          <v-btn
            :disabled="!validates && isReject"
            color="primary"
            text
            @click="updateStatus(keepStatus)"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title
          >Are you sure you want to remove this product</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteItem()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="statusDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title v-if="productDetail.status == 'Active'"
          >Are you sure you want to disable this Product?</v-card-title
        >
        <v-card-title v-if="productDetail.status == 'Inactive'"
          >Are you sure you want to enable this Product?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="statusDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="changeStatus()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="VariantstatusDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card v-if="VariantstatusDialog == true">
        <v-card-title v-if="variantdetails.status == 'Active'"
          >Are you sure you want to disable this Product?</v-card-title
        >
        <v-card-title v-if="variantdetails.status == 'Inactive'"
          >Are you sure you want to enable this Product?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="VariantstatusDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="changeVariantStatus()"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="600px" v-model="openStockDialog">
      <v-card width="600px" style="font-family: poppinsregular">
        <v-form v-model="addcat" ref="addcat">
          <v-layout wrap pa-5>
            <v-flex xs12 pb-5>
              <span> Add New Stock </span>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                type="number"
                label="Price (₹)"
                v-model="newStock.price"
                @input="chechProductTax(newStock.price, newStock.discount)"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                type="number"
                label="Discount (%)"
                v-model="newStock.discount"
                @input="chechProductTax(newStock.price, newStock.discount)"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                disabled
                dense
                outlined
                type="number"
                label="offerPrice(₹)"
                v-model="newStock.offerPrice"
              >
              </v-text-field>
            </v-flex>

            <v-flex xs12 lg6 px-1>
              <v-text-field
                disabled
                dense
                outlined
                type="number"
                label="Tax Amount(₹)"
                v-model="calculatedTax"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                disabled
                dense
                outlined
                type="number"
                label="Tax Percentage(%)"
                v-model="TaxPercentage"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="newStock.manufacturingDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[rules.required]"
                    dense
                    outlined
                    v-model="newStock.manufacturingDate"
                    label="Manufacturing Date "
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newStock.manufacturingDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(newStock.manufacturingDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="newStock.expiryDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[rules.required]"
                    dense
                    outlined
                    v-model="newStock.expiryDate"
                    label="Select Expiry Date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newStock.expiryDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu1 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu1.save(newStock.expiryDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                label="Shelf Life"
                v-model="newStock.shelfLife"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                type="number"
                label="Stock"
                v-model="newStock.stock"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                type="number"
                label="Purchase Amount"
                v-model="newStock.purchaseAmount"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-menu
                ref="menu3"
                v-model="menu3"
                :close-on-content-click="false"
                :return-value.sync="newStock.purchaseDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[rules.required]"
                    dense
                    outlined
                    v-model="newStock.purchaseDate"
                    label="purchase Date "
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newStock.purchaseDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu3 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu3.save(newStock.purchaseDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
               
                label="Batch Number"
                v-model="newStock.batchNumber"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 text-right>
              <v-btn
                color="primary"
                text
                @click="AddEditStock()"
                :disabled="!addcat"
              >
                save
              </v-btn>

              <v-btn
                color="error"
                style="padding-left 10px"
                text
                @click="openStockDialog = false"
              >
                close
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import axios from "axios";
import StockInfo from "../stock/stockView";
// import Review from "./customerReview";
// import Similarproduct from "./similarProduct";
export default {
  components: {
    // Review,
    // Similarproduct,
    StockInfo,
  },
  data() {
    return {
      calculatedTax: null,
      TaxPercentage: null,
      rules: {
        required: (value) => !!value || "Required.",
      },
      menu: false,
      menu1: false,
      menu3: false,
      addcat: false,
      openStockDialog: false,
      newStock: {},

      VariantstatusDialog: false,
      variantdetails: null,
      variants: [],
      addons: [],
      items: ["f2", "f1", "f3"],
      kg: "",
      productDetail: [],
      sellers: [],
      qty: 1,
      newprice: 0,
      verifyDelete: false,
      keepStatus: "",
      notice: "",
      isReject: false,
      validates: false,
      reason: "",
      appLoading: false,
      req: {
        required: (value) => !!value || "Required.",
      },
      deleteDialog: false,
      statusDialog: false,
      showSnackBar: false,
      ServerError: false,
      msg: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    chechProductTax(price, discount) {
      if ((price, discount)) {
        axios({
          url: "/grocery/calculate/product/tax",
          method: "get",
          headers: {
            token: localStorage.getItem("token"),
          },
          params: {
            price: price,
            discount: discount,
            hsnId: this.productDetail.hsnCodeId._id,
          },
        })
          .then((response) => {
            this.appLoading = false;

            if (response.data.status) {
              this.calculatedTax = response.data.TaxAmount.toFixed(2);
              this.TaxPercentage = response.data.TaxPercentage;
              this.newStock.offerPrice = response.data.offerPrice;
            } else {
              this.snackbar = true;
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },

    winStepper(item) {
      if (item.getData) {
        this.getData();
      }
    },
    checkDiscountvariant() {
      console.log(typeof this.newStock.discount);
      if (this.newStock.discount >= 0 && this.newStock.discount < 100) {
        this.newStock.offerPrice = parseInt(
          (
            this.newStock.price -
            (this.newStock.price * this.newStock.discount) / 100
          ).toFixed(2)
        );
        console.log(" this.newStock.offerPrice ", this.newStock.offerPrice);
      } else {
        this.msg = "Please Provide valid discount";
        this.showSnackBar = true;
        this.newStock.offerPrice = 0;
        this.newStock.discount = 0;
      }
    },
    AddEditStock() {
      this.newStock.hsnId = this.productDetail.hsnCodeId._id;
      this.appLoading = true;
      axios({
        url: "/grocery/product/add/stock",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },

        data: this.newStock,
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status) {
            this.newStock = {};
            this.openStockDialog = false;
            this.getData();
          } else {

            // console.log('showSnackBar',this.showSnackBar)
            
            this.showSnackBar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getData() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/grocery/admin/product/view",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.id,
        },
      }).then((response) => {
        if (response.data.status) {
          this.productDetail = response.data.data;

          // let mh = ["1","2","3","4"]
          // if( this.productDetail.length > 0)
          // {
          // this.productDetail.forEach((item) => {
          //   console.log("vvv", item);
          // });
          // }

          this.sellers = response.data.data;
          this.variants = response.data.varients;
          this.addons = response.data.data.addOnIds;
          this.appLoading = false;
          console.log(this.products);
        } else {
          this.appLoading = false;
          this.showSnackBar = true;
          this.msg = response.data.msg;
          // console.log("no data ");
        }
      });
    },

    deleteItem() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/grocery/product/delete",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.productDetail.productId._id,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$emit("stepper", {
              getData: true,
            });
            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.$router.go(-1);
          } else {
            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },
    verifyStatus(status) {
      this.verifyDelete = true;
      this.keepStatus = status;
      if (status == "approve")
        this.notice = "Do you want to approve this request?";
      else if (status == "reject") {
        this.isReject = true;
        this.notice = "Do you want to reject this request?";
      }
    },
    updateStatus(status) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/approve/reject",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.product,
          action: status,
          rejectReason: this.reason,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.getData();
            this.verifyDelete = false;
            this.$router.push("ProductList");
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    changeStatus() {
      this.loading = true;
      axios({
        method: "POST",
        url: "/grocery/product/status/change",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.productDetail.productId._id,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.status) {
            this.getData();
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },

    changeVariantStatus() {
      this.loading = true;
      axios({
        method: "POST",
        url: "/grocery/varient/status/change",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.variantdetails._id,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.status) {
            this.getData();
            this.VariantstatusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.VariantstatusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },

    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    getTimeFromMins(mins) {
      var num = mins;
      if (num >= 60) {
        var hours = num / 60;
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);

        return rhours + " hour(s) and " + rminutes + " minute(s).";
      } else return num + " minutes";
    },
  },
};
</script>
<style>
#container {
  position: relative;
}
#navi,
#infoi {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
#infoi {
  z-index: 10;
}
</style>